import { Button, ButtonProps } from "@chakra-ui/react"
import { BlockHeroButtonAction } from "@jackfruit/common"
import React, { MouseEventHandler } from "react"
import { useCloudProviderContext } from "~/components/cloud-provider/hooks/useCloudProviderContext"
import { useNextActionableBlock } from "~/hooks/useNextActionableBlock"

interface Props extends ButtonProps {
  label: string
  action: string
  customAction?: BlockHeroButtonAction
  isPrimary?: boolean
}

type ButtonStyleProps = Pick<
  ButtonProps,
  "colorScheme" | "color" | "variant" | "fontWeight"
>

const primaryButtonStyles: ButtonStyleProps = {
  colorScheme: "primary",
  color: "primary.text",
  variant: "solid",
}

const secondaryButtonStyles: ButtonStyleProps = {
  colorScheme: "blackAlpha",
  variant: "ghost",
}

const HeroButton: React.FC<Props> = props => {
  const { openCloudProviderModal } = useCloudProviderContext()

  const { nextBlockType } = useNextActionableBlock("hero")

  const scrollToNextActionableBlock = () => {
    if (nextBlockType && typeof window.scrollToElement === "function") {
      window.scrollToElement(nextBlockType)
    }
  }

  const { label, action, customAction = "", isPrimary } = props

  const style = isPrimary ? primaryButtonStyles : secondaryButtonStyles

  let onClick: MouseEventHandler = () => {}

  switch (action) {
    case "scrollToNextActionableBlock":
      onClick = scrollToNextActionableBlock
      break
    case "openCloudImageBrowser":
      onClick = openCloudProviderModal
      break
    case "custom":
      // customAction comes from the builder
      // there is no security risk here
      // eslint-disable-next-line no-eval
      onClick = () => eval(customAction)
      break
  }

  const className = `hero-button-${action}`

  return (
    <Button
      {...style}
      size="lg"
      aria-label={label}
      onClick={onClick}
      className={className}
    >
      {label}
    </Button>
  )
}

export default HeroButton
